<template>
    <HamletTable
        :columns="columns"
        :fetch="fetch"
    >
        <template #header-label>
            {{ $t('Page(Customers):Component(Text):page-label') }}
        </template>

        <template #cell-contacts="data">
            {{ renderContacts(data.item.contacts) }}
        </template>

        <template #cell-validFrom="data">
            {{ data.item.validFrom ? renderDate(data.item.validFrom) : '-' }}
        </template>

        <template #cell-validTo="data">
            {{ data.item.validTo ? renderDate(data.item.validTo) : '-' }}
        </template>
    </HamletTable>
</template>

<script>
import HamletTable from "@core/components/common/HamletTable";
import {SupplyChain} from "@core/api";
import {DateRenderer} from "@core/mixins";

export default {
    mixins: [DateRenderer],
    components: {
        HamletTable
    },
    data() {
        return {
            columns: [
                {
                    key: 'name',
                    label: this.$t('Component(Grid):column-name')
                },
                {
                    key: 'state',
                    label: this.$t('Component(Grid):column-state')
                },
                {
                    key: 'contacts',
                    label: this.$t('Component(Grid):column-contact')
                },
                {
                    key: 'validFrom',
                    label: this.$t('Component(Grid):column-valid-from')
                },
                {
                    key: 'validTo',
                    label: this.$t('Component(Grid):column-valid-to')
                },
            ],
        }
    },
    methods: {
        renderContacts(contacts) {
            if (contacts.length > 2) {
                return contacts.splice(0, 2).map(c => c.name).join(', ');
            }

            return contacts.map(c => c.name).join(', ');
        },
        fetch(config, cb) {
            SupplyChain.getCustomers([], {}, config.page, config.perPage).then(r => {
                cb(r.data.totalItems, r.data.items);
            });
        }
    }
}
</script>
